export default {"src":"/_next/static/media/pinterest.47132e80.svg","height":12,"width":10};